import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { withInMemoryScrolling } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import { importProvidersFrom } from '@angular/core';
import localeFr from '@angular/common/locales/fr';
import { ModalModule } from 'ngx-bootstrap/modal';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { provideRouter } from '@angular/router';
import { SocketIoModule } from 'ngx-socket-io';
import { LOCALE_ID } from '@angular/core';
import { MessageService } from 'primeng/api';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HttpExceptionInterceptor } from './services/http-exception.interceptor';
import { socketIoConfig } from './socket-io.config';
import { routes } from './app.routes';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            BrowserAnimationsModule,
            ModalModule.forRoot(),
            SocketIoModule.forRoot(socketIoConfig),
            NgbModule
        ),
        MessageService,
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    // keep PrimeNG styles in a lower-priority CSS layer so existing
                    // Bootstrap / global styles win any conflicts and current UI stays intact
                    cssLayer: { name: 'primeng', order: 'primeng' },
                    darkModeSelector: false
                }
            }
        }),
        provideHttpClient(
            withFetch(),
            withInterceptorsFromDi()
        ),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withInMemoryScrolling({
                scrollPositionRestoration: 'enabled',
                anchorScrolling: 'enabled',
            })
        ),
        provideClientHydration(withEventReplay()),
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
        }),
        {
            provide: LOCALE_ID,
            useValue: 'fr-FR'
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpExceptionInterceptor,
            multi: true
        }
    ],
};
